import { createTracker } from 'usage-tracker';
import type { ApprovalType } from 'ui-product-approvals-common';

export const tracker = createTracker({ standalone: true });

const getApp = () => window.location.pathname.split('/')[1];

export type TrackInteractionExtra = {
  approvalId?: number | number[];
  count?: number;
  isSkipped?: boolean;
  complete?: boolean;
  enabled?: boolean | null;
  rules?: string;
  dueDateDelta?: number;
  userType?: string;
  totalSteps?: number;
  userCount?: number;
  teamCount?: number;
  agentId?: string[];
};

export const trackInteraction = (
  interaction: string,
  approvalType: ApprovalType,
  extra?: TrackInteractionExtra
) =>
  tracker.track('Product Approvals', 'Product Approvals Interaction', {
    app: getApp(),
    interaction,
    type: approvalType,
    ...extra,
  });
